import { useEffect, useState } from 'react';
import { env } from '@/lib/env';

type Phase = 'starting' | 'done' | 'error';

export function NutritionConnect() {
  const params = new URLSearchParams(window.location.search);
  const status = params.get('status');
  const token = params.get('token');
  const [phase, setPhase] = useState<Phase>(
    status === 'done' ? 'done' : status === 'error' ? 'error' : 'starting',
  );

  useEffect(() => {
    if (phase !== 'starting') return;
    if (!token) { setPhase('error'); return; }
    // Abort on cleanup so React 18 StrictMode's mount/unmount/remount in dev
    // doesn't fire a second connect POST (each would mint a fresh OAuth token).
    const controller = new AbortController();
    void (async () => {
      try {
        const res = await fetch(
          `${env.apiBaseUrl}/connect/integrations/fatsecret/connect`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token }),
            signal: controller.signal,
          },
        );
        if (!res.ok) { setPhase('error'); return; }
        const { authUrl } = await res.json() as { authUrl?: string };
        if (authUrl) {
          window.location.href = authUrl;
        } else {
          setPhase('error');
        }
      } catch (err) {
        if ((err as DOMException).name !== 'AbortError') setPhase('error');
      }
    })();
    return () => controller.abort();
  }, [phase, token]);

  return (
    <div className="connect-wrap">
      {phase === 'starting' && <p>Connecting your nutrition…</p>}
      {phase === 'done' && (
        <>
          <h1>Connected</h1>
          <p>You're all set — your nutrition will sync automatically.</p>
        </>
      )}
      {phase === 'error' && (
        <>
          <h1>Link expired</h1>
          <p>Please ask your trainer to resend your connect link.</p>
        </>
      )}
    </div>
  );
}
